import React, { useEffect, useState } from "react";

const MAX_TIMEOUT_MS = 2_147_483_647;

const getSchedule = (marquee) => {
  if (!marquee?.enabled || !marquee?.message?.trim()) {
    return null;
  }

  const from = new Date(marquee.from_at).getTime();
  const to = new Date(marquee.to_at).getTime();
  if (!Number.isFinite(from) || !Number.isFinite(to) || from >= to) {
    return null;
  }

  return { from, to };
};

export default function InformationMarquee({ marquee }) {
  const [active, setActive] = useState(false);

  useEffect(() => {
    let timer;

    const refresh = () => {
      window.clearTimeout(timer);
      const schedule = getSchedule(marquee);
      const now = Date.now();
      const isActive = Boolean(
        schedule && now >= schedule.from && now <= schedule.to
      );
      setActive(isActive);

      if (!schedule) {
        return;
      }

      const nextBoundary =
        now < schedule.from
          ? schedule.from
          : now <= schedule.to
          ? schedule.to + 1
          : null;
      if (nextBoundary !== null) {
        timer = window.setTimeout(
          refresh,
          Math.min(Math.max(nextBoundary - now, 250), MAX_TIMEOUT_MS)
        );
      }
    };

    refresh();
    document.addEventListener("visibilitychange", refresh);
    return () => {
      window.clearTimeout(timer);
      document.removeEventListener("visibilitychange", refresh);
    };
  }, [marquee]);

  const message = marquee?.message?.trim();
  if (!active || !message) {
    return null;
  }

  const durationSeconds = Math.max(
    34,
    Math.min(70, Math.ceil(message.length * 0.6))
  );

  return (
    <div className="customer-marquee-column">
      <div className="customer-marquee" role="status">
        <span className="visually-hidden">{message}</span>
        <div
          className="customer-marquee__track"
          aria-hidden="true"
          style={{ animationDuration: `${durationSeconds}s` }}
        >
          <span className="customer-marquee__content">{message}</span>
          <span className="customer-marquee__content">{message}</span>
        </div>
      </div>
    </div>
  );
}
